module.exports = __webpack_public_path__ + "img/tune.79e6018.jpeg";